import * as Headless from '@sail/theme-headless';
import {css, theme} from '../theme';

export const FormFieldGroup = theme(Headless.FormFieldGroup, [
  css({
    padding: 0,
    margin: 0,
    borderWidth: css.value(0),
    '& > div': {
      gap: 'small',
    },
    '& > div > div': {
      flex: css.value('1 1 0px'),
    },
    [Headless.FormFieldGroupVariants.invalid.true]: {
      background: css.value('$color.critical50'),
      border: css.value('1px solid $color.critical100'),
      borderRadius: 'small',
      padding: 'small',
      margin: css.value('calc($space.100 * -1)'),
    },
  }),
]);
